import React from 'react';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';

import { TextInput } from '@producer/ui-kit';

type ContactSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
};

export const ContactSearchBar: React.FC<ContactSearchBarProps> = ({ value, onChange }) => (
  <TextInput
    value={value}
    icon={<MagnifyingGlassIcon />}
    placeholder={'Search'}
    onChange={(e) => onChange(e.target.value)}
    inline
  />
);
